import { Modal } from "@mui/material";
import React, { useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import {LoadingSpinner} from "../../../components/Icons";
import { IMG_VALIDATE } from "../../../constants/index";
import i18n from 'i18next';

const AvatarDialog = ({ open, onClose, onConfirm, onConfirmPopupOpen }: any) => {
    const fileRef = useRef<any>(null);
    const [isOver, setIsOver] = useState(false);
    const [file, setFile] = useState(null);
    const [errorAvatar, setErrorAvatar] = useState<string|null>(null);
    const { superUserLogged, loading } = useSelector( (state: any) => state.superUser);

    const validateFile = (blobFile: any) => {
        setFile(null);
        setErrorAvatar(null);
        if (blobFile && (blobFile.type === 'image/png' || blobFile.type === 'image/jpeg' || blobFile.type === 'image/gif')) {
            if (blobFile.size > IMG_VALIDATE.AVATAR_MAX_FILE_SIZE) {
                setErrorAvatar(i18n.t('MSG_GLOBAL_IMAGE_SIZE_EXCEEDS_LIMIT'));
                return;
            }
            setFile(blobFile);
        } else {
            setErrorAvatar(i18n.t('MSG_GLOBAL_FILE_MUST_BE_IMAGE'));
            return;
        }
    }

    const handleChangeFile = (e: any) => {
        if (e.target.files && e.target.files[0]) {
            validateFile(e.target.files[0]);
        }
        e.target.value = null;
    };

    const handleDragOver = (e: any) => {
        e.preventDefault();
        setIsOver(true);
    };

    const handleDragLeave = (e: any) => {
        e.preventDefault();
        setIsOver(false);
    };

    const handleDrop = (e: any) => {
        e.preventDefault();
        setIsOver(false);
    
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            const droppedFile = e.dataTransfer.files[0];
            validateFile(droppedFile);
        }
    };

    const handleOpenConfirm = () => {
        if(!superUserLogged.avatar) return;
        else onConfirmPopupOpen();
    }

    return (
        <Modal open={open} onClose={onClose}>
        <div className="bg-white rounded-2xl p-6 w-[480px] absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">
            <h2 className="text-2xl font-bold alu-text-base-2 mb-4">
                プロフィール画像の編集
            </h2>
            <p className="text-xs alu-text-base-2 mb-6">
            {`顔写真を登録できます。画像の形式は PNG, JPG, GIF に対応しています。画像の四辺は自動的に丸いかたちにくり抜かれて表示されます。`}
            </p>
            <div className="flex items-center justify-between gap-4 mb-2">
                <h5 className="text-sm font-bold alu-text-base-2">
                    プロフィール画像を選択
                </h5>
                {(superUserLogged?.avatar && !file) && <button
                    onClick={handleOpenConfirm}
                    className={`text-xs ${superUserLogged?.avatar ? "text-[#F33D62]" : "text-[#BBBBBB] hover:cursor-default"}`}
                >
                    現在の画像を削除...
                </button>}
                {!superUserLogged?.avatar && <button
                    onClick={handleOpenConfirm}
                    className={`text-xs ${superUserLogged?.avatar ? "text-[#F33D62]" : "text-[#BBBBBB] hover:cursor-default"}`}
                >
                    現在の画像を削除...
                </button>}
            </div>
            <div className="mb-10 relative w-[100%] h-[10rem]">
                <input
                    accept="image/*"
                    onChange={handleChangeFile}
                    type="file"
                    className="hidden"
                    ref={fileRef}
                />
                <div className="w-full absolute top-0 left-0">
                    <div
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    onClick={() => fileRef.current.click()}
                    className={`mb-2 hover:cursor-pointer w-full h-[10rem] ${
                        isOver ? "bg-[#009CF2]" : "bg-white"
                    } border border-dashed ${errorAvatar ? "border-[#F33D62]" : "border-[#E0E0E0]"} flex flex-col gap-4 items-center justify-center`}
                    >
                    {!file ? (
                        <>
                        {(!superUserLogged?.avatar || superUserLogged.delete_avatar) ? (
                            <>
                            <button>
                                <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="50"
                                height="56"
                                viewBox="0 0 50 56"
                                fill="none"
                                >
                                <g clipPath="url(#clip0_14268_15658)">
                                    <path
                                    d="M41.1615 14.0026H24.9999L20.9595 9.33594H8.83826C6.61603 9.33594 4.81805 11.4359 4.81805 14.0026L4.79785 42.0026C4.79785 44.5693 6.61603 46.6693 8.83826 46.6693H41.1615C43.3837 46.6693 45.2019 44.5693 45.2019 42.0026V18.6693C45.2019 16.1026 43.3837 14.0026 41.1615 14.0026ZM41.1615 42.0026H8.83826V18.6693H41.1615V42.0026ZM16.9191 30.3593L19.7675 33.6493L22.9797 29.9626V39.6693H27.0201V29.9626L30.2322 33.6726L33.0807 30.3593L25.0201 21.0026L16.9191 30.3593Z"
                                    fill={`${isOver ? "#fff" : "#808080"}`}
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_14268_15658">
                                    <rect
                                        width="48.4848"
                                        height="56"
                                        fill="white"
                                        transform="translate(0.757812)"
                                    />
                                    </clipPath>
                                </defs>
                                </svg>
                            </button>
                            <p
                                className={`text-sm leading-[1.3125rem] ${
                                isOver ? "text-white" : "alu-text-base-1"
                                } text-center`}
                            >
                                プロフィール画像をドラッグ、または
                                <br />
                                <span className="text-[#FF861A]">ファイルを選択</span>
                            </p>
                            </>
                            ) : (
                            <img
                                src={superUserLogged.avatar}
                                alt="uploaded_img"
                                className="w-16 h-16 rounded-full object-cover"
                            /> 
                        )}
                        </>
                    ) : (
                        <img
                        src={URL.createObjectURL(file)}
                        alt="uploaded_img"
                        className="w-16 h-16 rounded-full object-cover"
                        />
                    )}
                    </div>
                    {errorAvatar && (
                    <p className="text-sm text-[#F33D62] mt-2">{errorAvatar}</p>
                    )}
                    {file && (
                    <CustomButton
                        onClick={() => setFile(null)}
                        variant="text"
                    >
                        画像を取り消す
                    </CustomButton>
                    )}
                </div>
            </div>
            <div className="flex items-center justify-center gap-8">
                <CustomButton
                    type="button"
                    onClick={onClose}
                    variant="text"
                >
                    キャンセル
                </CustomButton>
                <CustomButton
                    disabled={loading || !file}
                    type="button"
                    onClick={() => {onConfirm(file); onClose();}}
                    size="md"
                >
                    <p>{loading ? "送信中..." : "保存"}</p>
                    {loading && (
                        <span><LoadingSpinner /></span>
                    )}
                </CustomButton>
            </div>
        </div>
        </Modal>
    );
};

export default AvatarDialog;
